<template>
  <div class="sui-tag" :class="tag_classes">
    <slot>
      <slot name="label">
        <div class="sui-tag__label">{{ tag_label }}</div>
      </slot>
      <slot name="icon">
        <div class="sui-tag__icon" >
          <Icon name="close" @click="onDoneIconClick"></Icon>
        </div>
      </slot>
    </slot>
  </div>
</template>

<script setup lang="ts">
  import { toRefs, computed } from 'vue';

  // Components
  import Icon from '../icon/Icon.vue'

  const props = defineProps({
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
  })

  const { label, disabled } = toRefs(props)

  const tag_classes = computed(() => {
    return {
      'sui-tag--disabled': disabled.value
    }
  })

  const tag_label = computed(() => {
    return label.value.length > 110 ? `${label.value.substring(0, 110)}...` : label.value
  })

  function onDoneIconClick() {
    console.log('Clicked!')
  }
</script>

<style scoped lang="scss">
.sui-tag {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 1;
  flex-grow: 0;
  gap: 8px;

  height: 28px;
  border-radius: 4px;
  padding: 6px 8px;
  background-color: var(--color-icon-secondary);
  overflow: hidden;
  font-size: 12px;
  line-height: 16px;
  color: var(--color-text-contrast);

  &--disabled {
    pointer-events: none;
    background-color: var(--color-button-disabled);
    color: var(--color-text-secondary)

  }

  &:hover {
    background-color: var(--color-lightbutton-hover);
  }

  &__icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    cursor: pointer;
  }
}
</style>
